







































































import { Component,Model, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";
import { GapTransportationCoordinationReportFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
  },
  computed: //mapState("gaps", ["priority"]),
            mapState("schedule", [ "priorities"]),
})
export default class PrioritiesFilter extends Vue {
   @Model("change") readonly filter!: GapTransportationCoordinationReportFilter;
  id = "priority-filter-popover";
  target = "priority-filter-target";
  priorities!: Array<any>;
  list = Array<any>();
  checkPriority() {
    this.list.forEach((s) => {
      s.checked = true;
    });
  }
  uncheckPriority() {
    this.list.forEach((s) => {
      s.checked = false;
    });
  }
  get checkedPriority(): Array<any> {
    return this.list
      .filter((s) => {
        return s.checked;
      })
      .map((s) => s.id);
  }
  search() {
    this.filter.apptPriorityList = JSON.parse(JSON.stringify(this.checkedPriority));
    this.$emit('refresh')
    this.close();
  }
  clear() {
    this.uncheckPriority();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { apptPriorityList } = this.filter; 
    this.list = JSON.parse(JSON.stringify(this.priorities)).map((p) => {
      p.checked = apptPriorityList.includes(p.id);
      return p;
    });
  }
}
